// extracted by mini-css-extract-plugin
export default {"flex-row":"FlexRow_flex-row__gUfxp","flex-col":"FlexRow_flex-col__K-YOA","flex-row-collapse":"FlexRow_flex-row-collapse__R+AzN"};